exports.name = 'hometownhousingtrust';
exports.host = 'hometownhousingtrust.kmdg/';
exports.debug = true;